// extracted by mini-css-extract-plugin
export default {"path":"energy-flow-path_path__H3s9q"};